<template>
  <div class="AiExpand" :class="{ 'AiExpand--reverse': reverse }">
    <slot name="activator" @click="activate">
      <ai-button
        :label="label"
        :aria-controls="controlsId"
        :aria-expanded="expanded"
        variant="tertiary"
        @click="activate">
        <template #right>
          <ai-icon
            :size="24"
            name="chevron-down"
            class="AiExpand-icon"
            :class="{ 'AiExpand-icon--expanded': expanded }" />
        </template>
      </ai-button>
    </slot>

    <div
      :id="controlsId"
      class="AiExpand-body"
      :class="{ 'AiExpand-body--expanded': expanded }">
      <slot />
    </div>
    <ai-separator v-if="expanded" :margin="0" />
  </div>
</template>

<script setup lang="ts">
type Props = {
  controlsId?: string;
  modelValue?: boolean;
  label?: string;
  reverse?: boolean;
};

type Emits = {
  (event: 'update:modelValue', value: boolean): void;
};

const props = withDefaults(defineProps<Props>(), {
  controlsId: '',
  label: undefined,
  modelValue: undefined,
  reverse: false,
});
const emits = defineEmits<Emits>();

const internalValue = ref(false);

const expanded = computed({
  get() {
    if (typeof props.modelValue === 'boolean') return props.modelValue;

    return internalValue.value;
  },
  set(value) {
    if (typeof props.modelValue === 'boolean') {
      return emits('update:modelValue', value);
    }

    internalValue.value = value;
  },
});

const activate = () => {
  expanded.value = !expanded.value;
};
</script>

<style scoped lang="scss">
.AiExpand {
  &--reverse {
    display: flex;
    flex-direction: column-reverse;
  }
}
.AiExpand-icon {
  display: inline-block;
  transition: transform 200ms;

  &--expanded {
    transform: rotate(180deg);
  }
}

.AiExpand-body {
  height: 0;
  overflow: hidden;

  &--expanded {
    height: fit-content;
    width: 100%;
  }
}
</style>
